import React, { useSyncExternalStore } from 'react';
import { geocodingIndicator } from '../services/geocodingIndicator';

const subscribe = geocodingIndicator.subscribe.bind(geocodingIndicator);
const getCount = () => geocodingIndicator.count;

const GeocodingOverlay = () => {
  const count = useSyncExternalStore(subscribe, getCount, getCount);
  if (count === 0) return null;
  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/40">
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl border border-gray-200 dark:border-gray-700 p-6 flex flex-col items-center gap-3">
        <div className="w-10 h-10 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
        <p className="text-sm font-semibold text-gray-700 dark:text-gray-200">
          Obteniendo datos para la geolocalización...
        </p>
      </div>
    </div>
  );
};

export default GeocodingOverlay;
